import { useTabsNavigation } from "components/base/Tabs";
import { Title } from "../../components/base/Title";

export default function MentionsLegales() {
  const { switchToTab } = useTabsNavigation();

  const handleLinkClick = (tabIndex: number) => {
    switchToTab(tabIndex);
  };
  
  return (
    <div className="p-6 max-w-4xl mx-auto leading-relaxed">
      <Title type="subdisplay" centered>Mentions légales</Title>
      <p className="text-gray-600 mb-6 text-center">
        <strong>Dernière mise à jour :</strong> 18 octobre 2025
      </p>

      <div className="space-y-8">
        <section>
          <p>
            Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique,
            il est porté à la connaissance des utilisateurs et visiteurs du site Le Rucher de Carole et Sylvain les présentes mentions légales.
          </p>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            1. Éditeur du site et directeur de publication
          </Title>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Informations générales</Title>
              <p><strong>Éditeur :</strong> Marion Lebas</p>
              <p><strong>Directeur de publication :</strong> Marion Lebas</p>
              <p><strong>Dénomination :</strong> Le Rucher de Carole et Sylvain</p>
              <p><strong>SIRET :</strong> 830 843 694 00027</p>
              <p><strong>TVA :</strong> Non assujettie à la TVA, article 293B du CGI</p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Coordonnées</Title>
              <p><strong>Adresse :</strong></p>
              <p>34 rue d'Elbeuf</p>
              <p>76100 Rouen</p>
              <p>France</p>
              <p><strong>E-mail :</strong>
                <a href="mailto:marionlebas.dev@gmail.com" className="text-primary-600 hover:underline ml-1">
                  marionlebas.dev@gmail.com
                </a>
              </p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">2. Hébergement</Title>
          <p><strong>Prestataire d'hébergement:</strong> OVH SAS, 2, rue Kellermann, 59100 Roubaix, France</p>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">3. Activité et services</Title>

          <div className="space-y-4">
            <p>Plateforme de commande et de livraison groupée de miel pour les communautés (entreprises, associations, groupes d'amis).</p>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold">Services proposés</Title>
              <ul className="list-disc list-inside space-y-1 text-gray-700">
                <li>Commande en ligne de produits apicoles</li>
                <li>Organisation de livraisons groupées</li>
                <li>Gestion des groupes de commande via des référents</li>
                <li>Suivi des commandes et livraisons</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">4. Propriété intellectuelle</Title>

          <p className="mb-4">
            L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle.
            Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
          </p>

          <Title type="h3" className="font-semibold mb-2">Marques et logos</Title>
          <p>
            Les marques et logos reproduits sur ce site sont déposés par les sociétés qui en sont propriétaires.
            Toute reproduction non autorisée de ces marques, dessins et modèles constitue une contrefaçon passible de sanctions pénales.
          </p>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">5. Protection des données personnelles</Title>

          <p className="mb-4">
            Le traitement des données personnelles collectées sur ce site est régi par notre
            <button 
              onClick={() => handleLinkClick(2)} 
              className="text-primary-600 hover:underline ml-1 cursor-pointer"
            >
              politique de confidentialité
            </button>.
          </p>

          <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Données collectées</Title>
              <p>Les données personnelles collectées incluent : nom, prénom, adresse e-mail, numéro de téléphone, informations de paiement (via Stripe), et données de livraison.</p>
            </div>
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2 mt-4">Finalités</Title>
              <p>Traitement des commandes, organisation des livraisons, gestion de la relation client, et administration de la plateforme.</p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">6. Cookies</Title>

          <p className="mb-4">
            Ce site utilise des cookies techniques nécessaires au bon fonctionnement de la plateforme et ne nécessitent pas votre consentement :
          </p>

          <div className="border border-gray-200 rounded-lg p-4">
            <ul className="space-y-2 text-gray-700">
              <li><strong>Cookies de session :</strong> Maintien de votre connexion utilisateur</li>
              <li><strong>Cookies de sécurité :</strong> Protection contre les attaques CSRF</li>
              <li><strong>Cookies de préférences :</strong> Mémorisation de vos choix d'interface</li>
            </ul>
          </div>


        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">7. Responsabilité et limitations</Title>

          <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Disponibilité du service</Title>
              <p>
                Nous nous efforçons de maintenir le site accessible 24h/24, 7j/7, mais ne pouvons garantir une disponibilité absolue.
                Des interruptions peuvent survenir pour maintenance ou cas de force majeure.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Liens externes</Title>
              <p>
                Le site peut contenir des liens vers d'autres sites web. Nous ne sommes pas responsables du contenu de ces sites externes
                ni des pratiques de confidentialité qu'ils appliquent.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Limitation de responsabilité</Title>
              <p>
                Dans les limites autorisées par la loi, Le Rucher de Carole et Sylvain ne pourra être tenu responsable des dommages directs ou indirects
                résultant de l'utilisation du site ou de l'impossibilité de l'utiliser.
              </p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">8. Droit applicable et juridiction</Title>

          <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Droit applicable</Title>
              <p>Les présentes mentions légales sont soumises au droit français.</p>
            </div>
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Juridiction compétente</Title>
              <p>En cas de litige, les tribunaux français seront seuls compétents. Tout litige sera soumis à la juridiction du tribunal compétent du lieu du siège social de l'entreprise.</p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">9. Contact</Title>

            <p className="mb-4">
              Pour toute question concernant ces mentions légales ou le fonctionnement du site :
            </p>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="border border-gray-200 rounded-lg p-4">
                <Title type="h3" className="font-semibold mb-2">Contact technique</Title>
                <p><strong>E-mail :</strong>
                  <a href="mailto:marionlebas.dev@gmail.com" className="text-primary-600 hover:underline ml-1">
                    marionlebas.dev@gmail.com
                  </a>
                </p>
              </div>

              <div className="border border-gray-200 rounded-lg p-4">
                <Title type="h3" className="font-semibold mb-2">Adresse postale</Title>
                <p>34 rue d'Elbeuf, 76100 Rouen France</p>
              </div>
            </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">10. Modifications</Title>

          <p>
            Ces mentions légales peuvent être modifiées à tout moment. Les modifications entrent en vigueur dès leur publication sur le site.
            Nous vous encourageons à consulter régulièrement cette page pour prendre connaissance des éventuelles modifications.
          </p>
        </section>
      </div>
    </div>
  );
}
